<template>
  <div id="about">
    <popup v-if="selectedTeam"  :popupData="selectedTeam"></popup>
    <!-- <canvas></canvas> -->
    <main id="main" data-page-id="home">
      <section class="innerpage_header" data-scroll-section="h1">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>
        <div class="innerpage_header_textbox">
          <h1> About us</h1>
        </div>

        <a class="next_slide" v-on:click="NextSlide()">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" width="60px" height="60px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;"
            xml:space="preserve">

            <defs>
            </defs>
            <path class="st0" d="M60,30C60,13.5,46.5,0,30,0S0,13.5,0,30s13.5,30,30,30S60,46.5,60,30z M29.2,45.6l-15-22
            C14.1,23.4,14,23.2,14,23c0-0.2,0-0.3,0.1-0.5c0.2-0.3,0.5-0.5,0.9-0.5h30c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.2,0.7-0.1,1l-15,22
            C30.6,45.8,30.3,46,30,46S29.4,45.8,29.2,45.6z" />
          </svg>

        </a>
      </section>


      <section class="about centerRow s2 us" data-scroll-section="h2">
        <div class="container">
          <div class="row  ">
             <div class="col-md-8 col-sm-12 col-xs-12">

              <h3>
                About Us
              </h3>
              <!-- <p>
             MI Inc is a lifelong dream of founder and CEO Abdul Loul. Through his life’s journey and
challenging young life as a child growing up in Syria Abdul never stopped dreaming. His dream is our
reality today in the name of MI Inc.
              </p>
  <p>
Abdul Loul’s journey towards technology and intelligence led him to earn his bachelor's degree in
computer science. MI Inc. was born in the United States after Abdul Loul completed his MBA
in Finance from New Jersey City University in 2020, after almost 11 years of postgraduate education.
Abdul Loul’s journey
     </p>
       <p>
MI Inc is founded on the need to partner with the largest players in the consumer electronics
industry with the aim of standardizing the market, building the structure and foundation from real-time
market data to create healthy marketplaces to help businesses become successful and profitable.
 </p>
   <p>
MI aims to be instrumental in the industry by providing financial and technological
intelligence and solutions through its unique and innovative intelligence solutions across the globe.
 </p> -->
  
 
              <p>
                MI Inc. is founded to partner with the largest players in the consumer electronics industry with the aim of standardizing the market through the use of real-time market data to create healthy marketplaces to help businesses become successful and profitable.
              </p>
<p>
        MI provides financial and technological intelligence solutions through its unique and innovative in-house built pricing engine and networking tool.

              </p>
              <p>
              </p>
              <p>
              </p>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="logo_about">
                <img src="../../../assets/img/1.png">
              </div>

            </div>
          </div>
        </div>

      </section>


      <section class="about_col3 centerRow" data-scroll-section="h3">
        <video autoplay loop muted src="../../../assets/video/about.mp4"></video>
        <div class="container">
          <div class="row ">
            <div class="col-md-4">
              <h4>OUR Vision</h4>
              <p>
                <ul class="p-t-0">
                  <li> Become instrumental in the industry by providing financial and technological intelligence and solutions</li>
                  <li>
                    Build the structure and foundation from real-time market data to create healthy marketplaces and to help businesses become successful and profitable
                  <li>
Globalize and Standardize the Consumer Electronics industry and partner with the market’s largest players
                  </li>
                </ul>
              </p>
            </div>
            <div class="col-md-4">
              <h4>OUR Mission </h4>
              <p>
                MI’s team is exceedingly ambitious and passionate about the innovative solutions it provides that benefit the entire Consumer Electronics industry. Our hope is that the same model can be applied to other industries to spread market intelligence. Our main goals are increasing efficiency, transparency, and reliability between businesses around the world.
              </p>
            </div>
            <div class="col-md-4">
              <h4>OUR Strategy</h4>
              <p>
               Our strategy is built on our corporate values, this will enable us to continue to be successful through our development in the coming years to achieve our short and long-term goals. <br>
The basis for our strategy is based on a few major metrics: Identify, Simplify, Solve, and Inspire! This was derived from a detailed analysis of major long-term market deficiencies identified over the course of many years.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="ourteam centerRow" data-scroll-section="h4">

        <div class="sectionTitle">
          <h4> Management Team and Board of Directors</h4>
          <p>
             Meet our senior leadership team, our technical experts, and some members of our board. From software engineers to developers, MBAs to Ph.D.'s  Our team is made of a diverse group of people from all walks of life that bring only the best of the best skill sets to the table

          </p>
        </div>
        <div class="ourteam_images">
          <a class="ourteam_images__item" v-for="(item,index) in teaminfo" v-bind:key="index" 
            @click="showTeamInfo(item)"
            :style="'background-image:url('+ item.image +')'">
            <div class="border_team"></div>
          <!-- :href="item.linkedin" -->

            <div class="team__photo__description">
              <h4>{{item.fullname}}</h4>
              <p>{{item.position}}</p>
            </div>
          </a>

        </div>

      </section>


      <section class="started-section" >
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>

        <div class="container row started__container">
          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">Where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <router-link class="button button--white-hover-trans pulse" to="/contact">Contact</router-link>
              <a href="#" class="button button--transparent pulse">our team</a>
            </div>
          </div>
        </div>
      </section>


      <section class="o-eric-progress e-scrol">
        <div class="c-eric-progress-container">
          <div class="c-eric-progress">
            <div class="c-eric-progress__counter">
              <div class="c-eric-progress__counter-zero">0</div>
              <div class="c-eric-progress__counter-item">

              </div>
            </div>
            <div class="c-eric-progress-el">

            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import global from '@/mixins/global';
  import team from '../../assets/data/teaminfo';
  import popup from './popup/index';
  export default {
    name: 'About',
    data() {
      return {
        teaminfo:undefined,
        selectedTeam:undefined
      };
    },
    mixins: [global],
    mounted() {
      this.teaminfo = team.data
    },
    components:{
      popup
    },
    methods:{
      closePopup(){
        this.selectedTeam = undefined ;
      },
      showTeamInfo(info){
        this.selectedTeam = info    
           }
    },
    metaInfo: {
      title: 'About',
      // titleTemplate: '%s | vue-meta Example App'
    },
  };

</script>
<style lang="scss">
@import "./style"

</style>



// WEBPACK FOOTER //
// src/components/About/index.vue